import { BaseApiClient } from '@/services/baseApiClient';
import { uploadFile } from '@/utils/request';
import { BugReportFormField } from '@enmon/commons/lib/enmon';
import type { AskNewMeterModelArg, AskNewMeterModelResult, BugReportArg, BugReportResult } from './types/types';

export class SupportApiClient extends BaseApiClient {
  constructor() {
    super('api/support');
  }

  public async reportBug({ message, attachments, context }: BugReportArg): Promise<BugReportResult> {
    const formData = new FormData();
    attachments.forEach((file: File) => formData.append(BugReportFormField.Attachments, file));

    const data = {
      message,
      context,
    };
    formData.append(BugReportFormField.Data, JSON.stringify(data));

    return await uploadFile(`${this.http.urlPrefix}/report-bug`, formData);
  }

  public async askNewMeterModel({
    message,
    attachments,
    context,
  }: AskNewMeterModelArg): Promise<AskNewMeterModelResult> {
    const formData = new FormData();
    attachments.forEach((file: File) => formData.append('attachments', file));

    const data = {
      message,
      context,
    };
    formData.append('data', JSON.stringify(data));

    return await uploadFile(`${this.http.urlPrefix}/ask-new-meter-model`, formData);
  }
}
